import styled, { css } from 'styled-components';

export const DashboardActive = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.875rem;
    line-height: 0.875rem;
    height: 2rem;
    width: 5.625rem;
    align-items: center;
    justify-content: center;
    color: var(--green);
    background: rgba(71, 212, 68, 0.1);
    border-radius: 6.25rem;
`

export const DashboardDisabled = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 0.875rem;
    line-height: 0.875rem;
    align-items: center;
    justify-content: center;
    background: rgba(184, 184, 184, 0.1);
    height: 2rem;
    width: 6.1875rem;
    color: var(--grey-100);
    border-radius: 6.25rem;
`

export const DashboardEllipsed = styled.td`
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 1.2rem;
  text-overflow: ellipsis;
`

export const DashboardEllipsedSm = styled.td`
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 1.2rem;
  text-overflow: ellipsis;
`

type DashboardArrowProps = {
  isArrowUp: boolean;
};

export const DashboardArrow = styled.img<DashboardArrowProps>`
  ${({ isArrowUp }) =>
    isArrowUp &&
    css`
      transform: rotate(180deg);
    `}
`

type PolicemenVariants = 'off' | 'working' | 'ready'

type PolicemenProps = {
    variant: PolicemenVariants
}

const policemenVariants = {
    off: css`
        &::before {
            margin-right: 0.2rem;
            content: "•";
            font-size: 1.4rem;
            color: var(--red);
        }
    `,
    working: css`
        &::before {
            margin-right: 0.2rem;
            content: "•";
            font-size: 1.4rem;
            color: var(--primary);
        }
    `,
    ready: css`
        &::before {
            margin-right: 0.2rem;
            content: "•";
            font-size: 1.4rem;
            color: var(--green);
        }
    `
}

export const DashboardEllipsedPolicemen = styled.td<PolicemenProps>`
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 1.2rem;
  text-overflow: ellipsis;

  ${({ variant }) =>
    variant && policemenVariants[variant]
    }
`

export const DashboardEllipsedSmPolicemen = styled.td<PolicemenProps>`
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 1.2rem;
  text-overflow: ellipsis;

  ${({ variant }) =>
    variant && policemenVariants[variant]
    }
`


export const DashboardFlex = styled.td`
    display: flex;
    flex-direction: row;
    padding-left: 0 20px;
    /* width: 90px; */
    button {
       font-weight: 500;
    }
    button:last-of-type {
       margin-left: 0.5rem;
    }
`

export const ApproveButton = styled.td`
    width: 6.5625rem;
    button {
      font-weight: 500 !important;
    }
    button:last-of-type {
      margin-left: 0.5rem;
    }
    display: flex;
    flex-direction: row;
`

export const SearchBarContainer = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
`